<template>
    <div>
        <dropdown-component>
            <template #trigger>
                <button
                    type="button"
                    class="
                        flex
                        items-end
                        cursor-pointer
                        text-xs text-secondary
                        font-medium
                        tracking-wide
                        hover:text-primary
                        focus:outline-none
                    "
                >
                    Sort
                    <span v-if="originalSort">
                        :
                        {{ sortTypes[originalSort] }}
                    </span>
                    <i class="icon-np-arrow-dropdown text-xl"></i>
                </button>
            </template>

            <template #content>
                <dropdown-button
                    v-for="(type, key) in sortTypes"
                    :key="key"
                    @click="sort(key)"
                >
                    {{ type }}
                </dropdown-button>
            </template>
        </dropdown-component>
    </div>
</template>

<script>
import DropdownComponent from "@/Components/Dropdown";
import DropdownButton from "@/Components/DropdownButton";

export default {
    components: {
        DropdownComponent,
        DropdownButton,
    },
    data() {
        return {
            sortTypes: {
                alphabetAsc: "A - Z",
                alphabetDesc: "Z - A",
                dateDesc: "Newest - Oldest",
                dateAsc: "Oldest - Newest",
                priceAsc: "Least Expensive",
            },
        };
    },
    methods: {
        sort(key) {
            this.$emit("sort", key);
        },
    },
    props: {
        originalSort: {
            type: String,
            default: null,
        },
    },
};
</script>
